import { gameUpdateEvents } from "../events/game-update-events";

export const pollGameUpdateStatus = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  setInterval(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/game-update-status`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
    
      console.log("pollGameUpdateStatus");

      if (data.isUpdating) {
        gameUpdateEvents.setUpdating(true, data.message);
      } else {
        gameUpdateEvents.setUpdating(false);
      }
    } catch (err) {
      console.error('Failed to fetch game update status:', err);
    }
  }, 30000); 
};
